import { useIsMobile } from '@maxpreps/shared/hooks/useIsScreenSize';
import Checkbox from '@maxpreps/shared/ui/Checkbox/Checkbox';
import React from 'react';
import useScheduleContext from '../ScheduleContext';

const ScheduleCheckboxCell = ({ contest }) => {
  const isMobile = useIsMobile();
  const scheduleContext = useScheduleContext();
  const { selectedContests, setSelectedContests } = scheduleContext;
  const { contestId } = contest;

  const toggleContest = () => {
    const index = selectedContests.findIndex(c => c.contestId === contestId);
    if (index < 0) {
      setSelectedContests([...selectedContests, contest]);
    } else {
      setSelectedContests(
        selectedContests.filter(c => c.contestId !== contestId)
      );
    }
  };

  return (
    <td>
      <Checkbox
        checked={selectedContests.some(a => a.contestId === contestId)}
        onChange={toggleContest}
        size={isMobile ? 16 : 20}
      />
    </td>
  );
};

export default ScheduleCheckboxCell;
